import { useRef, useEffect } from 'react';
import { InputComponent } from './input';

interface Props {
  value: string;
  onChange: (value: string) => void;
  onBlur: () => void;
  error?: string;
  label?: string;
}

export const CurrencyInput = ({
  value,
  onChange,
  onBlur,
  error,
  label,
}: Props) => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
  const el = inputRef.current;
  if (el && document.activeElement === el) {
    requestAnimationFrame(() => {
      const len = el.value.length;
      el.setSelectionRange(len, len);
    });
  }
}, [value]);



  return (
    <InputComponent
      ref={inputRef}
      value={value}
      label={label ?? 'Valor'}
      type="text"
      onChange={e => onChange(e.target.value)}
      onFocus={e => {
        const len = e.target.value.length;
        e.target.setSelectionRange(len, len);
      }}
      onClick={() => {
        const el = inputRef.current;
        if (el) {
          const len = el.value.length;
          el.setSelectionRange(len, len);
        }
      }}
      onBlur={onBlur}
      hint={error}
      variant={error ? 'danger' : 'default'}
    />
  );
};
